import React from 'react';
import { Navigate } from 'react-router';
import VisitsPage from './components/VisitsPage';
import { HIDE_SYSTEM_ROUTE } from '../../configs';

const routes = [
  // {
  //   path: '/',
  //   component: () => <Navigate to="/visits" />,
  //   weight: 2,
  //   hideOnMenu: HIDE_SYSTEM_ROUTE,
  //   permission: [],
  //   children: [],
  //   loginRequired: true,
  // },
  {
    path: '/visits',
    name: 'menu.visits',
    icon: 'visits',
    customIcon: true,
    loginRequired: true,
    component: VisitsPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
